import React, { Fragment, useState, useEffect } from 'react';
import { Link, useHistory } from 'react-router-dom';
import { postData } from '../../../apiService';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import { faS } from '@fortawesome/free-solid-svg-icons';
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import CancelIcon from '@mui/icons-material/Cancel';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { Tooltip } from '@mui/material';


const ProductCategoryCreate = (props) => {
    const history = useHistory();
    const { isAuthenticated, companyId, userId, logout, token } = useAuth();
    const [name, setName] = useState("");
    const [code, setCode] = useState("");
    const [isLoading, setIsLoading] = useState(false);

    const [gstRate, setGstRate] = useState("");
    const [isSubmit, setisSubmit] = useState(false);
    const [successMessage, setSuccessMessage] = useState("");
    const [errorMessage, setErrorMessage] = useState("");

    useEffect(() => {
        // Check if the token is expired
        if (isAuthenticated && tokenIsExpired(token)) {
            // Token is expired, log out the user
            logout();
            return;
        }

    }, [isAuthenticated, companyId, token, logout]);

    const clearForm = () => {
        setName("");
        setGstRate("0");
    };

    const submitData = async (e) => {
        e.preventDefault();
        setIsLoading(true);

        if (!name) {
            setErrorMessage("All fields are required!");
            setisSubmit(false);
            setIsLoading(false);
            return;
        }

        const CreateData = {
            Name: name,
            Code: code,
            GSTRate: gstRate,
            CreatedBy: userId,
            CompanyId: companyId,
            CreatedDate: new Date(),
        };

        postData('CategoryApi', CreateData, token)
            .then((response) => {
                console.log('Category Created success:', response);
                setSuccessMessage("Category Created successfully!");
                setErrorMessage("");
                clearForm();
                history.push('/ProductCategoryIndex');
                setTimeout(() => {
                    setSuccessMessage("");
                }, 3000);
            })
            .catch((error) => {
                console.error('Item Create error:', error);
                setIsLoading(false);
            });
    };

    return (
        <Fragment>
            <div className="w-full max-w-sm container mt-2 mx-auto">
                <form onSubmit={submitData}>

                    <div className='w-full mb-2 flex items-center'>
                    <h6 className='productHead flex-grow linkcolor' style={{ color: 'black', fontFamily: 'Georgia, serif', fontWeight: 'bolder' }}>PRODUCT CATEGORY CREATE</h6>
                        <Tooltip title="Exit">
                            <Link to="/ProductCategoryIndex" style={{ color: 'red', textDecoration: 'none', fontWeight: 'bolder' }}>
                                <Button style={{ color: 'red', fontWeight: 'bolder' }}>
                                    Back-To-List <ExitToAppIcon />
                                </Button>
                            </Link>
                        </Tooltip>


                        <Tooltip title="SAVE">

                            <Button onClick={submitData} style={{ color: 'green', fontWeight: 'bolder' }} disabled={isLoading}>
                                {isLoading ? <CircularProgress size={24} color="inherit" /> : "SAVE"} <CheckCircleIcon />
                            </Button>

                        </Tooltip>
                    </div>
                    {errorMessage && <p className="text-red-500">{errorMessage}</p>}
                    {successMessage && <p className="text-green-500">{successMessage}</p>}

                    <div className="w-full mb-4 flex">

                        <div className="w-1/2 mr-2">
                            <label className="block tracking-wide text-black text-base font-bold mb-2" htmlFor="name">
                                Item Name
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                value={name}
                                onChange={(e) => setName(e.target.value)}
                                type="text"
                                placeholder="Enter Item Name"
                            />
                        </div>

                        <div className="w-1/8 mr-2">
                            <label className="block tracking-wide text-black text-base font-bold mb-2" htmlFor="name">
                                Code
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                value={code}
                                onChange={(e) => setCode(e.target.value)}
                                type="text"
                                placeholder="Enter Code"
                            />
                        </div>

                        <div className="w-1/8 mr-2">
                            <label className="block tracking-wide text-black text-base font-bold mb-2" htmlFor="rate">
                                GST Rate
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline text-right"
                                value={gstRate}
                                onChange={(e) => setGstRate(e.target.value)}
                                type="number"
                                placeholder="Enter GST Rate"
                            />
                        </div>
                    </div>

                </form>
            </div>
        </Fragment>
    );
}

export default ProductCategoryCreate;

